<template>
  <div class="container no-padding-container text-gray-600">
    <div class="px-5">
      <div class="pt-5 md:pt-12">
        <h1 class="ota-title mb-3 text-center md:mb-10" v-text="$t('RightOfWithdrawal.General.Title')" />
        <div class="py-10">
          <RightOfWithdrawalComponent />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RightOfWithdrawalComponent from '@/components/RightOfWithdrawalComponent'

export default {
  name: 'RightOfWithdrawal',
  components: { RightOfWithdrawalComponent },
  layout: 'homepage',
  head () {
    return {
      title: this.$t('RightOfWithdrawal.General.Title'),
      meta: [
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.$t('RightOfWithdrawal.General.Description')
        }
      ]
    }
  }
}
</script>
